import React from 'react';
import ListToolbar from '@/components/ui/List.Toolbar';
import type { TypeListFindBar } from '@/types/list/types.list.find';

const ListFind: React.FC<{ bar: TypeListFindBar }> = ({ bar }) => (
    <ListToolbar
        search={bar.search}
        onSearch={bar.onSearch}
        placeholder={bar.placeholder}
        sections={bar.sections}
        active={bar.active}
        onToggle={bar.onToggle}
        excluded={bar.excluded}
        onExclude={bar.onExclude}
        onClear={bar.onClear}
        dates={bar.dates}
        dateValues={bar.dateValues}
        onDateChange={bar.onDateChange}
        sort={bar.sort}
        shown={bar.shown}
        total={bar.total}
        right={bar.right}
    />
);

export default ListFind;
